import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { PlanChangePreviewState } from '../plan-change-preview/plan-change-preview.component';

export interface ConfirmPlanDialogResult {
  confirmed: boolean;
  prorationDate: number | null;
}

@Component({
    selector: 'convfact-confirm-plan-dialog',
    templateUrl: './confirm-plan-dialog.component.html',
    styleUrls: ['./confirm-plan-dialog.component.css'],
    standalone: false
})
export class ConfirmPlanDialogComponent {

  plan: any;
  period: string;
  total: number;
  billingText: string;
  couponApplied: boolean;
  couponCode: string;
  couponDiscount: number;
  couponDescription: string;
  couponNote: string;
  isPlanChange: boolean;
  preview: PlanChangePreviewState = { loading: false, loaded: false, prorationDate: null };

  constructor(
    public dialogRef: MatDialogRef<ConfirmPlanDialogComponent, ConfirmPlanDialogResult>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.plan = data.plan;
    this.period = data.period;
    this.total = data.total;
    this.billingText = data.billingText;
    this.couponApplied = data.couponApplied;
    this.couponCode = data.couponCode;
    this.couponDiscount = data.couponDiscount || 0;
    this.couponDescription = data.couponDescription;
    this.couponNote = data.couponNote;
    this.isPlanChange = data.isPlanChange === true && !!data.plan;
    this.preview = { loading: this.isPlanChange, loaded: false, prorationDate: null };
  }

  get periodLabel(): string {
    return this.period === 'year' ? 'año' : 'mes';
  }

  get showCatalogTotal(): boolean {
    return !this.isPlanChange || (!this.preview.loading && !this.preview.loaded);
  }

  onPreviewState(state: PlanChangePreviewState): void {
    this.preview = state;
  }

  confirm(): void {
    this.dialogRef.close({ confirmed: true, prorationDate: this.preview.prorationDate });
  }

  cancel(): void {
    this.dialogRef.close({ confirmed: false, prorationDate: null });
  }
}
